import styled, { css } from 'styled-components'
import { SearchMode } from 'src/types/search'

interface IProps {
  mode: SearchMode
}

export const PaxSelectorWrapper = styled.div<IProps>`
  padding-block-end: 20px;

  ${({ mode }) =>
    mode === SearchMode.Full &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
    `};
`

export const PaxesMobileHeader = styled.div<IProps>`
  display: none;

  & > svg {
    cursor: pointer;
  }

  ${({ mode }) =>
    mode === SearchMode.Full &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-size: 1.1em;
      font-weight: 700;
      padding-inline-start: 1em;
      color: ${props => props.theme.colors.grey2};
      padding-block: 20px;
      padding-inline: 20px;
    `};
`

export const LinkButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  font-family: var(--font-grotesk);
  color: ${props => props.theme.colors.brand1};
`

export const PaxSelectorContent = styled.div<IProps>`
  ${({ mode }) =>
    mode === SearchMode.Full &&
    css`
      flex: 1;
      overflow: auto;
      width: 100%;
    `};
`

export const PaxesFooter = styled.div`
  padding-block: 0;
  padding-inline: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  border-block-start: 1px solid ${props => props.theme.colors.grey5};
  padding-block-start: 20px;
`
